var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AreaFormModel, UploadFileFormModel } from '.';
import { TargetAreaTypes } from '../Constants';
var TemporaryAutomobileMenuSettingFormModel = /** @class */ (function () {
    function TemporaryAutomobileMenuSettingFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, _b = _a.orderDescription, orderDescription = _b === void 0 ? {} : _b, uploadFile = _a.uploadFile;
        var _c = orderDescription, _d = _c.extractionCondition, extractionCondition = _d === void 0 ? '' : _d, _e = _c.target, target = _e === void 0 ? {} : _e, _f = _c.administrativeDistrictType, administrativeDistrictType = _f === void 0 ? TargetAreaTypes.PREFECTURE : _f, area = _c.area, _g = _c.splitGroup, splitGroup = _g === void 0 ? false : _g, _h = _c.memo, memo = _h === void 0 ? '' : _h;
        var tct = TargetCarTypeFormModel.assign(extractionCondition === 'car_type' ? target : {});
        var tbocn = TargetBrandOrCarNameFormModel.assign(extractionCondition === 'brand_or_car_name' ? target : {});
        var tfrym = TargetFirstRegistrationYearMonthFormModel.assign(extractionCondition === 'first_registration_year_month' ? target : {});
        var tvie = TargetVehicleInspectionExpirationFormModel.assign(extractionCondition === 'vehicle_inspection_expiration' ? target : {});
        var tm = TargetMileageFormModel.assign(extractionCondition === 'mileage' ? target : {});
        var tdicc = TargetDomesticImportedCarClassificationFormModel.assign(extractionCondition === 'domestic_imported_car_classification'
            ? target
            : {});
        this.id = id;
        this.orderDescription = {
            extractionCondition: extractionCondition,
            targetCarType: tct,
            targetBrandOrCarName: tbocn,
            targetFirstRegistrationYearMonth: tfrym,
            targetVehicleInspectionExpiration: tvie,
            targetMileage: tm,
            targetDomesticImportedCarClassification: tdicc,
            target: target,
            administrativeDistrictType: administrativeDistrictType,
            area: AreaFormModel.assign(area),
            splitGroup: splitGroup,
            memo: memo,
        };
        this.uploadFile = UploadFileFormModel.assign(uploadFile);
    }
    Object.defineProperty(TemporaryAutomobileMenuSettingFormModel.prototype, "isSimulatable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    TemporaryAutomobileMenuSettingFormModel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.orderDescription.area.init(this.orderDescription.administrativeDistrictType)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TemporaryAutomobileMenuSettingFormModel;
}());
export { TemporaryAutomobileMenuSettingFormModel };
var TargetCarTypeFormModel = /** @class */ (function () {
    function TargetCarTypeFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item.carTypes, carTypes = _a === void 0 ? [] : _a;
        this.carTypes = carTypes;
    }
    TargetCarTypeFormModel.assign = function (item) {
        return new TargetCarTypeFormModel(item);
    };
    return TargetCarTypeFormModel;
}());
var TargetBrandOrCarNameFormModel = /** @class */ (function () {
    function TargetBrandOrCarNameFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item.brandNames, brandNames = _a === void 0 ? [] : _a;
        this.brandNames = brandNames;
    }
    TargetBrandOrCarNameFormModel.assign = function (item) {
        return new TargetBrandOrCarNameFormModel(item);
    };
    return TargetBrandOrCarNameFormModel;
}());
var TargetFirstRegistrationYearMonthFormModel = /** @class */ (function () {
    function TargetFirstRegistrationYearMonthFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.startYear, startYear = _b === void 0 ? 2000 : _b, _c = _a.startMonth, startMonth = _c === void 0 ? 1 : _c, _d = _a.endYear, endYear = _d === void 0 ? 2019 : _d, _e = _a.endMonth, endMonth = _e === void 0 ? 3 : _e;
        this.startYear = startYear;
        this.startMonth = startMonth;
        this.endYear = endYear;
        this.endMonth = endMonth;
    }
    TargetFirstRegistrationYearMonthFormModel.assign = function (item) {
        return new TargetFirstRegistrationYearMonthFormModel(item);
    };
    return TargetFirstRegistrationYearMonthFormModel;
}());
var TargetVehicleInspectionExpirationFormModel = /** @class */ (function () {
    function TargetVehicleInspectionExpirationFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.startYear, startYear = _b === void 0 ? 2020 : _b, _c = _a.startMonth, startMonth = _c === void 0 ? 4 : _c, _d = _a.endYear, endYear = _d === void 0 ? 2022 : _d, _e = _a.endMonth, endMonth = _e === void 0 ? 3 : _e;
        this.startYear = startYear;
        this.startMonth = startMonth;
        this.endYear = endYear;
        this.endMonth = endMonth;
    }
    TargetVehicleInspectionExpirationFormModel.assign = function (item) {
        return new TargetVehicleInspectionExpirationFormModel(item);
    };
    return TargetVehicleInspectionExpirationFormModel;
}());
var TargetMileageFormModel = /** @class */ (function () {
    function TargetMileageFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.minMileage, minMileage = _b === void 0 ? 0 : _b, _c = _a.maxMileage, maxMileage = _c === void 0 ? 1 : _c;
        this.minMileage = minMileage;
        this.maxMileage = maxMileage;
    }
    TargetMileageFormModel.assign = function (item) {
        return new TargetMileageFormModel(item);
    };
    return TargetMileageFormModel;
}());
var TargetDomesticImportedCarClassificationFormModel = /** @class */ (function () {
    function TargetDomesticImportedCarClassificationFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item.domesticImportedCarClassification, domesticImportedCarClassification = _a === void 0 ? 'domestic' : _a;
        this.domesticImportedCarClassification = domesticImportedCarClassification;
    }
    TargetDomesticImportedCarClassificationFormModel.assign = function (item) {
        return new TargetDomesticImportedCarClassificationFormModel(item);
    };
    return TargetDomesticImportedCarClassificationFormModel;
}());
